import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import PenjelasanSimpanPage from 'containers/pages/webManagement/penjelasanSimpan/List'
import PenjelasanSimpanForm from 'containers/pages/webManagement/penjelasanSimpan/Form'

const PenjelasanSimpan = ({
  currentUser, location, match,
}) => {
  if (location.pathname === '/web-management/penjelasan-simpan') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-web-managementpenjelasan-simpan-read') > -1) {
      return <PenjelasanSimpanPage location={location} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('edit') || location.pathname.includes('add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-web-managementpenjelasan-simpan-write') > -1) {
      return <PenjelasanSimpanForm location={location} match={match} />
    }
    return <ForbiddenPage />
  }

  return ''
}

PenjelasanSimpan.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default PenjelasanSimpan
